import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Dialog, DialogContent, DialogActions, TextField, Button, Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { Leads } from '../../api/Endpoints/Leads';
import { LoadingButton } from '@mui/lab';
const SiteVisits = ({ ID, func, isUpdateComponent, setisUpdateComponent, disablebutton, data }) => {
    const [open, setOpen] = useState(false);
    const [date, setDate] = useState(data?.site_visit_date || dayjs(new Date()));
    const [formButtonStatus, setFormButtonStatus] = useState({
        label: 'Submit',
        loading: false,
        disabled: false,
    });

    const { control, handleSubmit } = useForm();

    const handleSave = async (data) => {
        setFormButtonStatus({ ...formButtonStatus, loading: true, disabled: true });
        const dataToSubmit = {

            id: ID,
            site_visit_remarks: data.remark,
            site_visit_date: dayjs(date).format('YYYY-MM-DD')
        };
        try {
            await Leads.update(dataToSubmit);
            toast.success('Site Visit Updated', { autoClose: 2000 });
            setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });
        } catch (err) {
            console.log("err", err);
            setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });
        }
        setOpen(false)
        setisUpdateComponent && setisUpdateComponent(false)
        func && func()
    };

    const handleClose = () => {
        setOpen(false);
        setisUpdateComponent && setisUpdateComponent(false)
    };

    return (
        <>
            {!disablebutton && (
                < Button color="primary" variant="outlined" onClick={() => setOpen(true)}>
                    Add Site Visit
                </ Button>

            )
            }

            <Dialog open={isUpdateComponent || open} onClose={handleClose}>
                <form onSubmit={handleSubmit(handleSave)}>
                    <DialogContent sx={{ mt: 5 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <DatePicker
                                        value={date} // Set value to the 'date' state
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Date" fullWidth />
                                        )}
                                        onChange={(newValue) => setDate(newValue)} // Update the 'date' state on change
                                        inputFormat="DD-MM-YYYY"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Controller
                                        control={control}
                                        name="remark"
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                label="Remark"
                                                multiline
                                                rows={4}
                                                defaultValue={data?.site_visit_remarks}
                                                variant="outlined"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </LocalizationProvider>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant="outlined" color="error">
                            Cancel
                        </Button>
                        <LoadingButton loading={formButtonStatus.loading}
                            disabled={formButtonStatus.disabled}
                            variant="outlined" type="submit">{formButtonStatus.label}</LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
};

export default SiteVisits;
